import { AppBarTitle } from "@components/app-bar-title";
import { createContextQuick } from "@components/quick-context";
import { RiSearchFill } from "@icon/react-icons";
import { QueryParamsAdapter, useAtomicTrigger, useMountedGetter } from "@lib/common";
import IconButton from "@material-ui/core/IconButton";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import * as companyContentService from '@api/company-content';
import { isEqual } from 'lodash';
import { filter, map } from 'rxjs/operators';
import { EnhancedTable } from "../table/mtable";
import { SentencesSubRow } from "./sentence-sub-rows";
import { isSinglePartyDeal } from "@lib/deals";
import { grey } from "@material-ui/core/colors";
import { searchC3PageRelations } from "@api/c3";
import { useSnackbar } from "notistack";
import {columns} from './columns/index'


export const [RefreshCounterProvider, useRefreshCounter] =
  createContextQuick<{
    refreshCounter: number;
    forceRefresh: () => any;
  }>();

  export default function AdvancedC3PageRelationSearch() {
  const [refreshCounter, setRefreshCounter] = useState(0);
  const { loading, data, trigger: fetchData, pageCount, rowCount } = useServerData();
  const location = useLocation();
  
  const initial: any = useMemo(() => {
    if (!location.search) {
      return null;
    }
    const params = QueryParamsAdapter.fromParams(location.search);
    if (params && params.sortBy)
      (params.sortBy as Array<Object>).forEach(
        x => (x['desc'] = x['desc'] === 'false' ? false : true)
      );
    // return params;
    return {
      ...params,
      ...(params.pageIndex ? { pageIndex: +params.pageIndex } : {}),
      ...(params.pageSize ? { pageSize: +params.pageSize } : {}),
    };
  }, []);

  useEffect(() => {
    // Reset the initial pagination if it was set
    // by query params
    if (initial) {
      initial.pageSize = 10;
      initial.pageIndex = 0;
    }
  }, []);

  useEffect(()=>{
    fetchData
  },[data])

  return (
    <>
      <AppBarTitle>
        <IconButton color="inherit">
          <RiSearchFill />
        </IconButton>{' '}
       C3 Page - Content to Person Relations Search
      </AppBarTitle>
      <RefreshCounterProvider
        refreshCounter={refreshCounter}
        forceRefresh={() => setRefreshCounter(counter => counter + 1)}>
       <EnhancedTable
          loading={loading}
         getSubRows={() => <></>}
          pageCount={pageCount}
          rowCount={rowCount}
          initial={initial}
          columns={columns}
          updateData={fetchData}
          data={data}
          getRowProps={colorMultiPartyRows} 
        />
      </RefreshCounterProvider>
    </>
  );
}
const colorMultiPartyRows = row =>
  !isSinglePartyDeal(row.original) ? { style: { background: grey[100] } } : {};

function useServerData() {
  const history = useHistory();
  const isMounted = useMountedGetter();

  const { loading, error, result, trigger } = useAtomicTrigger(
    ({ sortBy, pageSize, pageIndex, filters }, goToPage) => {
      // Update URL
      const nextState = { sortBy, pageSize, pageIndex, filters };
      const defaultState = { sortBy: [], pageSize: 25, pageIndex: 0, filters: [] };
      const state = Object.fromEntries(
        Object.entries(nextState).filter(([k, v]) => !isEqual(defaultState[k], v))
      );

      const shouldClear = !Object.keys(state).length;
      history.replace({ search: shouldClear ? '' : '?' + QueryParamsAdapter.toParams(state).toString() });

      // Observable
     return searchC3PageRelations({ page_size:pageSize, page: pageIndex + 1, sortBy, filters }).pipe(
  filter(() => isMounted()), // only emit if component is mounted
  map(d => ({
    ...d,
    data: Array.isArray(d.data) ? d.data : [] // ensure data is always an array
  }))
);
    }
  );
  // Extract values from result
  const data = result?.data ?? [];
  const count = result?.count ?? 0;
  const page_size = result?.page_size ?? 25;
  return {
    loading,
    error,
    rowCount: count,
    pageCount: Math.ceil(count / page_size),
    data,
    trigger,
  } as const;
}
